import * as Yup from "yup";
import { createValidationRule } from "../../../commonComponent/validation/validation";

export const serviceValidation = Yup.object({
  name: Yup.string().required("Name is required"),
  doctorId: Yup.string().required("Doctor is required"),
  code: Yup.string().required("Code is required"),
  description: Yup.string().required("Description is required"),
  price: createValidationRule("number"),
  startdate: Yup.date().required("Start date is required"),
  enddate: Yup.date(),
});
